module.exports = __webpack_public_path__ + "img/1454316676.4e82ab65.jpg";